var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRepeatSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 4.2l-4-3a1 1 0 00-1.05-.09A.977.977 0 0012 2v2H1a1 1 0 000 2h11v2a.988.988 0 00.55.89.99.99 0 001.05-.09l4-3a1 1 0 000-1.6zM.4 12.2l4-3a1 1 0 011.05-.09A.977.977 0 016 10v2h11a1 1 0 010 2H6v2a.988.988 0 01-.55.89.99.99 0 01-1.05-.09l-4-3a1 1 0 010-1.6z"
  })));
}

export default __webpack_public_path__ + "4123a8127a40bd0b231a5489b72e971c.svg";
export { SvgRepeatSwap as ReactComponent };